'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('./entityProvider'),
    EntityProvider = _require.EntityProvider;

var _require2 = require('./entityProvider'),
    EntitySchemaProvider = _require2.EntitySchemaProvider;

var _require3 = require('./entityProvider'),
    schemaRegistry = _require3.schemaRegistry;

var fobclient = require('..');
var moment = require('moment');

module.exports.BaseEntity = function () {
  function BaseEntity() {
    _classCallCheck(this, BaseEntity);

    this._id = null;
    this._dirty = null; // flag to allow reconstructing unsafed ('dirty') resources
    this._stringRep = null;
    this._url = null;
    this._createUser = null;
    this._createDate = null;
    this._updateUser = null;
    this._updateDate = null;
    this._entityName = null;
  }

  _createClass(BaseEntity, [{
    key: 'init',
    value: function init(data) {
      var schema = EntitySchemaProvider(data._entityName);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.keys(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (_typeof(data[key]) === 'object') {
            if (Array.isArray(data[key])) {
              this[key] = data[key].map(function (x) {
                return new (EntityProvider(x._entityName))(x);
              });
              // TODO: shouldn't it be like this?
              // this[key] = data[key].map(x => {
              //   let e = new (EntityProvider(x._entityName))(x)
              //   e.init(x)
              //   return e
              // })
            } else if (data[key] !== null) {
              this[key] = new (EntityProvider(data[key]._entityName))(data[key]);
            }
          } else if (typeof data[key] !== 'undefined') {
            if (schema && schema.properties && schema.properties[key]) {
              if (schema.properties[key].format === 'date-time') {
                this[key] = new Date(data[key]);
                // this[key] = moment(data[key], moment.ISO_8601).toDate()
              } else if (schema.properties[key].format === 'maybe-naive-date') {
                // this null case is actually caught before because weirdly in JavaScript
                // `typeof null === 'object'` holds, so we never enter this else branch
                // 8 lines above
                //
                // extend to a full ISO timestamp just to be sure because we can't possibly
                // test what every version of every browser does with just a naive date
                var fullTimestamp = data[key] + 'T00:00:00.000Z';
                this[key] = new Date(fullTimestamp);
              } else {
                this[key] = data[key];
              }
            } else {
              this[key] = data[key];
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (data._links) {
        this._url = data._links.self.href;
      }
    }
  }, {
    key: 'genericResolve',
    value: function genericResolve(refName) {
      return fobclient.genericResolveRefs(this)(refName);
    }
  }, {
    key: 'genericJSON',
    value: function genericJSON(_ref) {
      var fields = _ref.fields,
          links = _ref.links;

      var schema = EntitySchemaProvider(this._entityName);
      var json = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (schema && schema.properties && schema.properties[key]) {
            if (schema.properties[key].format === 'maybe-naive-date') {
              if (this[key] == null) {
                json[key] = null;
              } else {
                // Sweden is the same timezone as Germany and uses ISO8601 formatted date strings
                json[key] = this[key].toLocaleDateString('sv');
              }
            } else {
              json[key] = this[key];
            }
          } else {
            json[key] = this[key];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = links[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _key = _step3.value;

          var value = this[_key];
          if (value) {
            if (Array.isArray(value)) {
              json[_key] = value.map(function (λx) {
                return λx._url;
              });
            } else {
              json[_key] = value._url;
            }
          } else {
            // preserve null values, otherwise references can't be deleted (= set to null)
            json[_key] = null;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return json;
    }
  }, {
    key: 'fetchReference',
    value: function fetchReference(ref) {
      return this.genericResolve(ref);
    }
  }, {
    key: 'fetchQuery',
    value: function fetchQuery(query) {
      var _this = this;

      return Promise.all(Object.entries(query).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            val = _ref3[1];

        // the empty object {} marks the end of recursion
        var doRecurse = !(Object.keys(val).length === 0 && val.constructor === Object);
        if (doRecurse) {
          return _this.fetchReference(key).then(function (ref) {
            if (Array.isArray(ref)) {
              return Promise.all(ref.map(function (y) {
                return y.fetchQuery(val);
              }));
            } else {
              return ref.fetchQuery(val);
            }
          });
        } else {
          return _this.fetchReference(key);
        }
      }));
    }
  }]);

  return BaseEntity;
}();


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/baseEntity.js
// module id = EzvX
// module chunks = 0